import StatusBar from './StatusBar/StatusBar';

export default StatusBar;